<template>
  <div id="app">
      <router-view ></router-view>
  </div>
</template>

<script>

import Home from "./pages/Home.vue"

export default {
    name: "App",
    components: {
        Home
    }
}
</script>

<style>
* {
    margin: 0;
    padding: 0;
    list-style: none;
}

html{
    margin: 0;
    padding: 0;
}

body{
    width: 1920px;
    margin: 0;
    padding: 0;
    margin: 0 auto 0
    
}
#app {

}
</style>



// WEBPACK FOOTER //
// src/App.vue